const addCommas = (num: string) => {
	let z = num
		.replace(/[^0-9.]/gi, '')
		.replace(/^0+/, '')
		.replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
	if (z.indexOf('.') === 0) {
		z = '0' + z;
	}
	if (num.includes('.')) {
		z = z.substring(0, z.indexOf('.') + 3);
	}
	return z;
};

const formatCurrencyString = (amount: string) => {
	const numberAmount = parseFloat(amount);
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});
	return formatter.format(numberAmount);
};

const formatCurrencyNumber = (amount: number) => {
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});
	return formatter.format(amount);
};

export { addCommas, formatCurrencyString, formatCurrencyNumber };
